import { render, staticRenderFns } from "./OVSpareParts.vue?vue&type=template&id=1ff11014&scoped=true&lang=pug"
import script from "./OVSpareParts.vue?vue&type=script&lang=js"
export * from "./OVSpareParts.vue?vue&type=script&lang=js"
import style0 from "./OVSpareParts.vue?vue&type=style&index=0&id=1ff11014&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff11014",
  null
  
)

export default component.exports